import React from 'react'
import { Remove } from '@material-ui/icons'
import { TopNavBarButton } from '../GJKit/Buttons/TopNavBarButton'

const MinimizeCall = () => {
  const handleOnMinimizeCall = () => {
    window.parent.postMessage({ type: 'gojiraf-minimize' }, '*')
  }

  return (
    <TopNavBarButton
      id="event-click-minimize"
      data-test="minimize-call"
      onClick={handleOnMinimizeCall}
    >
      <Remove />
    </TopNavBarButton>
  )
}

export { MinimizeCall }
